import { render } from "./Metaverse.vue?vue&type=template&id=46837fa5&scoped=true"
const script = {}

import "./Metaverse.vue?vue&type=style&index=0&id=46837fa5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46837fa5"]])

export default __exports__